import { render, staticRenderFns } from "./TalentFilesView.vue?vue&type=template&id=53f16280"
import script from "./TalentFilesView.vue?vue&type=script&lang=ts"
export * from "./TalentFilesView.vue?vue&type=script&lang=ts"
import style0 from "./TalentFilesView.vue?vue&type=style&index=0&id=53f16280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports